import '@tabler/core/dist/js/tabler.js';
import onDomReady from '../../utils/dom/onDomReady';
import { initPasswordReveal } from '../../utils/form/passwordReveal';
import { initDeleteActionHandler } from '../../utils/form/deleteActionHandler';
import { initSlugify } from '../../utils/form/slugify';
import { initConfirmSubmit } from '../../utils/form/confirmSubmit';
import { initCountryStateSync } from '../../utils/form/countryStateSync';

onDomReady(() => {
  initPasswordReveal();
  initDeleteActionHandler();
  initSlugify();
  initConfirmSubmit();
  initCountryStateSync();
});
